import React, { useState, useEffect } from 'react';

const VariableSelector = ({ onVariablesChange }) => {
  const [variables, setVariables] = useState([
    'plasma_temperature',
    'plasma_density', 
    'magnetic_field'
  ]);
  const [inputValue, setInputValue] = useState('');

  // Notify parent whenever variables change
  useEffect(() => {
    if (onVariablesChange) {
      onVariablesChange(variables);
    }
  }, [variables, onVariablesChange]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addVariable();
    }
  };

  const addVariable = () => {
    const trimmedValue = inputValue.trim().toLowerCase();
    if (trimmedValue && !variables.includes(trimmedValue)) {
      setVariables([...variables, trimmedValue]);
      setInputValue('');
    }
  };

  const removeVariable = (variableToRemove) => {
    setVariables(variables.filter(v => v !== variableToRemove));
  };


  const formatVariableName = (variable) => {
    return variable
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold text-gray-900">Select Variables to Extract</h2>
      
      {/* Input Field */}
      <div className="relative">
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleInputKeyDown}
          placeholder="Type variable name and press Enter or comma..."
          className="w-full px-4 py-3 border border-gray-300 rounded-xl text-primary-600 bg-transparent focus:ring-2 focus:ring-primary-500 focus:border-transparent outline-none transition-all placeholder-white"
        />
        <button
          onClick={addVariable}
          disabled={!inputValue.trim()}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 px-3 py-1 bg-primary-600 text-white rounded-lg text-sm font-medium hover:bg-primary-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
        >
          Add
        </button>
      </div>

      {/* Variables Chips */}
      <div className="flex flex-wrap gap-2 min-h-[3rem]">
        {variables.map((variable) => (
          <div
            key={variable}
            className="inline-flex items-center gap-2 px-3 py-2 bg-primary-600 text-white rounded-full text-sm font-medium shadow-soft"
          >
            <span>{formatVariableName(variable)}</span>
            <button
              onClick={() => removeVariable(variable)}
              className="w-5 h-5 rounded-full bg-primary-700 hover:bg-primary-800 flex items-center justify-center transition-colors"
            >
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        ))}
        {variables.length === 0 && (
          <div className="text-gray-500 text-sm italic">
            No variables selected. Add some variables above.
          </div>
        )}
      </div>


      {/* Help Text */}
      <p className="text-sm text-gray-600">
        Type variable names and press Enter or comma to add them. Click the X on any chip to remove it.
      </p>
    </div>
  );
};

export default VariableSelector;

